import React, { useEffect, useState } from "react";
import { makeStyles } from '@mui/styles';
import { Card } from "../components/Card";
import { useUsers } from "../hooks/useUsers";
import { useSedes } from "../hooks/useSedes";
import dayjs from "dayjs";
import { useTurnos } from "../hooks/turns/useTurnos";
import { convertirLetraMayus } from "../helpers/convertirLetraMayus";
import { ObtenerPrimerDiaSemana } from "../helpers/obtenerDiaSemana";

export const Principal = () => {

    const classes = useStyles();
    const { users } = useUsers();
    const { sedes } = useSedes();

    const { turnos, total } = useTurnos({
        estado: 4,
        creado: { $gte:`${ dayjs().format('YYYY') }-${ dayjs().format('MM') }-${ ObtenerPrimerDiaSemana() }T00:00:00.000Z`, $lte:`${ dayjs().format('YYYY-MM-DD') }T23:59:59.999Z` }
    });

    return (
        <div className={ classes.main }>
            <Card title='Usuarios' total={ users?.length } icon='person-outline' size='25%' />
            <Card title='Sedes' total={ sedes?.length } icon='earth-outline' size='25%' />
            <Card title={ `Turnos (esta semana)` } total={ total } icon='ticket-outline' size='50%'>
                <ChildrenCard turnos={ turnos } sedes={ sedes } />
            </Card>
        </div>
    )
};

const ChildrenCard = (props) => {

    const { turnos, sedes } = props;
    const [datos, setDatos] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        let subscribed = true;
        subscribed && setDatos(sedes.map(sede => ({ sede: sede?.nombre, total: turnos?.filter(turno => turno?.sede?._id === sede?.uid).length })));

        return () => subscribed = false;
    }, [turnos]);

    return (
        <div className={ classes.childrenMain }>
            { datos.map(dato => (
                <div key={ dato?.sede } className={ classes.sedes }>
                    <div className={ classes.circle }></div>
                    <div className={ classes.texts }>
                        <span className={ classes.title }>{ convertirLetraMayus(dato?.sede) }</span>
                        <span className={ classes.subTitle }>{ dato?.total }</span>
                    </div>
                </div>
            )) }
        </div>
    );
}

const useStyles = makeStyles({
    main: {
        width: '100%',
        display: 'flex',
        gap: 20
    },
    childrenMain: {
        display: 'flex',
        gap: 50,
        justifyContent: 'center'
    },
    sedes: {
        display: 'flex',
        alignItems: 'center'
    },
    texts: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center'
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#9a9a98',
        marginBottom: -10,
    },
    subTitle: {
        fontSize: 40,
        fontWeight: 500,
        color: '#494949'
    },
    circle: {
        background: '#00365F',
        width: 12,
        height: 12,
        borderRadius: '50%',
        marginRight: 20
    }
});